import * as React from 'react';
import { IconChevronRightSmall16, LinkButton, UIText1 } from '@cian/ui-kit';

import * as styles from './BookingExistsContent.css';

interface IBookingExistsContentProps {
  href: string;
  description: string;
}

export const BookingExistsContent: React.FC<IBookingExistsContentProps> = ({ href, description }) => {
  return (
    <div className={styles['container']}>
      <UIText1>{description}</UIText1>
      <LinkButton
        fullWidth
        size="M"
        target="_blank"
        href={href}
        afterIcon={<IconChevronRightSmall16 color="current_color" />}
      >
        К заявке
      </LinkButton>
    </div>
  );
};
